<app-modal-container [title]="header"
  [subtitle]="subtitle"
  [buttons]="modalButtons"
  [greenTitle]="greenTitle"
  [spinnerProps]="spinnerProps"
  [bigSize]="false"
  [applyActivated]="isSecurityProtection ? true : password === 'thinktwice'"
  [showWhiteSpace]="showWhiteSpace"
  [innerModal]="innerModal"
  [titleDirection]="'start'"
  (closeButtonClicked)="close()"
  (applyButtonClicked)="confirmCheckingPassword()"
  (dismissButtonClicked)="close()">
  <ng-content></ng-content>
  <div class="{{contentDirection}}-column-container column-gap-0p5 font-4">
    <span *ngIf="showIUnderstand" class="bold600">I understand that:</span>
    <span *ngIf="!showIUnderstand && showDescription && textForDescription" class="opacity0p64 max-width-16">{{textForDescription}}</span>
      <app-modal-delete-list  *ngIf="mainText"
        [useStandardList]="useStandardList"
        [showIcons]="!showDescription"
        [textList]="mainText">
      </app-modal-delete-list>
     <ng-container *ngIf="showInput">
      <ng-container *ngIf="showConfirm">
        <span >Confirm by typing
          <span class="red-11 bold600">thinktwice</span>
          below.
        </span>
        </ng-container>
    </ng-container>
    <app-input 
      *ngIf="showInput" 
      data-qa="modal-dialog-password-input"
      class="flex width-100pcnt pd-top-0p5"
      [inputID]="'modalDialogInput'"
      [(input)]="password"
      [type]="isSecurityProtection ? 'password': ''" 
      [placeholder]="isSecurityProtection ? 'password' :'thinktwice'"
      [hideText]="false"
      [bottomText]="isPasswordInvalid ? 'Invalid password': ''"
      [additionalClass]="isPasswordInvalid ? 'error': ''">
    </app-input>
  </div>
</app-modal-container>

